import axios from './axios';
import SETTINGS from '../settings'
export default {
  getTeamMembers(cb) {
    axios.get(`${SETTINGS.API_BASE_PATH}/teammember?_embed=1&_sort=order`, ).then(response => {
      cb(response.data)
    }).catch(e => {
      console.log(e)
    })
  },
  getTeamMember(id, cb) {
    axios.get(`${SETTINGS.API_BASE_PATH}/teammember?_embed=1?_embed=1&idUser=${id}`).then(response => {
      cb(response.data)
    }, e => {
      console.log(e)
    })
  },
  saveTeamMember(teamMember, cb) {
    axios.post(`${SETTINGS.API_BASE_PATH}/saveteammemberprofile`, teamMember).then(response => {
      cb(response.data)
    }, e => {
      console.log(e)
    })
  }
}